import { PageHeader, Page, PageContent, Box, Text } from 'grommet';
import Iframe from 'react-iframe';

export const ContentDisplay = ({ title, subtitle, iframeUrl }) => {
  return (
    <Page flex="grow" background="background-back">

      {/* Banner Section */}
      <Box background="url('/images/home-banner.png')" height="200px" margin={{ top: 'none' }}>
        <Box margin={{ top: 'none', left: 'large' }}>
          <PageHeader 
            pad={{ top: '15px', bottom: '15px' }} 
            title={<Text color="black" size="xxlarge" weight="bolder" style={{ fontWeight: 'bold' }}>{title}</Text>} 
            subtitle={subtitle ? subtitle : undefined} 
            style={{ color: 'black' }}
            size="medium" 
          />
          {/* Possible future search bar addition here... */}
        </Box>
      </Box>

      <PageContent flex="grow">
        <Box flex="grow" pad={{ top: '40px' }} overflow="hidden"> 
          <Iframe 
            url={iframeUrl}
            allowFullScreen
            width="100%" 
            height="100%" 
            frameBorder="0"
            id="iframe-content"
            className=""
            style={{ border: 'none', overflow: 'hidden' }}  
          />
        </Box>
      </PageContent>

    </Page>
  );
};




